var CHECKBOX_WRAPPER_CLASS = 'rentpingCheckboxWrapper';
var menuItemToScrollIntoView = null;
var bannerContent = document.getElementById('banner-content');

function wrapCheckbox(element) {
    var parentEl = element.parentNode,
        isWrapped = parentEl.classList.contains(CHECKBOX_WRAPPER_CLASS);

    if (!isWrapped) {
        //According to https://developer.mozilla.org/en-US/docs/Web/API/Document/createDocumentFragment this will use memory instead of causing a bunch of html reflows.
        var fragment = document.createDocumentFragment(),
            checkboxWrapper = document.createElement('div'),
            fakeCheckbox = document.createElement('div'),
            checkboxEls = Array.from(parentEl.childNodes);

        fakeCheckbox.classList.add('fakeCheckbox');
        fakeCheckbox.classList.add('border-primary');
        checkboxWrapper.classList.add(CHECKBOX_WRAPPER_CLASS);
        fragment.appendChild(checkboxWrapper);
        fakeCheckbox.innerHTML = '<svg class="checkmarkSvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.04 7.53" aria-label="checkbox"><path class="checkmarkPath" d="M2.51,6.81l.72.72L10,.72,9.32,0ZM0,4.3,2.51,6.81l.72-.72L.72,3.59Z"/></svg>';

        checkboxEls.splice(1, 0, fakeCheckbox);
        wrapElements(checkboxEls, checkboxWrapper);
        wrapElements([checkboxWrapper], parentEl);

        var input = checkboxWrapper.querySelector('input[type="checkbox"]');

        fakeCheckbox.addEventListener('click', function () {
            input.click();
        });
    }
}

function wrapCheckboxes(parentElement) {
    var checkboxes = parentElement.querySelectorAll('.standard-checkbox');
    Array.prototype.forEach.call(checkboxes, wrapCheckbox);
}

function trackPhoneCall(page, appendSlug) {
    if (appendSlug) {
        page += window.location.pathname;
    }
    trackEvent('Lead', 'MobileClickToCall', page);
}

function trackPhoneText(page, appendSlug) {
    if (appendSlug) {
        page += window.location.pathname;
    }
    trackEvent('Lead', 'MobileClickToText', page);
}

function prepMobileFloorplanScroller(overflowId, scrollerId, floorplansId, contentPanelId, appendedBlockHeight) {
    var $contentPanel = $(contentPanelId),  				// includes the arrows
        $scroller = $(scrollerId),							// the full scrolling panels of slides
        $floorplans = $scroller.find(floorplansId),			// each floorplan slide pane.
        $overflow = $(overflowId);							// the window viewing

    const slidePercentage = $floorplans.length === 1 ? 1 : 0.85; // single slide takes the whole width
    $floorplans.removeAttr('style');					// remove any previously set widths/css
    var scrollWidth = $overflow.outerWidth();				// width of the viewing window
    let floorplanWidth = scrollWidth * slidePercentage;
    $floorplans.width(floorplanWidth);							// (re)sets width of images
    floorplanWidth -= 24;                                      // subtract 24 px to account for slide left margin
    if ($floorplans.length === 1) {
        $floorplans.addClass('single-slide');
        floorplanWidth -= 24;                                      // subtract another 24 px to account for slide right margin
    }
    var slideHeight = (floorplanWidth * 2 / 3 + appendedBlockHeight);
    $(contentPanelId + ' .photoWrapper').css({height: slideHeight.toString() + 'px'});  // set height of photo image
}

function toggleMobileMenuOpen() {
    const docEl = document.documentElement;
    const MENU_OPEN_CLASS_NAME = 'menuOpen';
    const header = document.getElementsByTagName('header')[0];
    const mobileMenuWrapper = header.getElementsByClassName('mobileMenuWrapper')[0];
    const mobileMenuLinks = Array.from(mobileMenuWrapper.getElementsByTagName('a'));
    const bottomStickyBar = document.querySelector('.bottomStickyBar');

    if (docEl.classList.contains(MENU_OPEN_CLASS_NAME)) {
        // close the menu
        docEl.classList.remove(MENU_OPEN_CLASS_NAME); // close menu

        //if not at the top of the page, slide the sticky bar down
        if (bottomStickyBar && window.pageYOffset > 0) {
            bottomStickyBar.classList.add('slide-down');
        }
    } else {
        // open the menu
        docEl.classList.add(MENU_OPEN_CLASS_NAME);
        if (document.querySelectorAll('.banner-content').length > 0 && header.offsetTop > 0) { // banner is visible & we need to scroll up
            window.scroll(0, header.offsetTop);
        }
        if (bottomStickyBar) {
            bottomStickyBar.classList.remove('slide-down'); //make sure all the sticky bar is visible when menu is open
        }
        setTimeout(() => {
            if (menuItemToScrollIntoView) {
                menuItemToScrollIntoView.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
            // hack to fix external link icon not showing up on mobile menu in SAFARI because SAFARI
            header.querySelectorAll('.external-link-icon').forEach((svg) => {
                svg.style.display = 'none';
                setTimeout(() => {
                    svg.style.display = 'block';
                }, 1);
            });
        }, 100);
    }
}


function initializeMobileMenu() {
    const header = document.getElementsByTagName('header')[0];
    const mobileMenuTrigger = header.getElementsByClassName('mobileMenuTrigger')[0];
    const headerFloorplansToggle = document.querySelector('.header-floorplans-toggle');
    const mobileMenuWrapper = header.getElementsByClassName('mobileMenuWrapper')[0];
    const mobileMenuLinks = Array.from(mobileMenuWrapper.getElementsByTagName('a'));

    mobileMenuTrigger.addEventListener('click', function () {
        toggleMobileMenuOpen();
    });

    headerFloorplansToggle.addEventListener('click', function () {
        const headerFloorplansList = $('.header-floorplans-list');
        if (headerFloorplansList.is(':hidden')) {
            trackGA4Event('nav_floorplans_dropdown_open');
        }
        headerFloorplansList.slideToggle();
        //toggle arrow
        document.querySelectorAll('.header-floorplans-toggle-arrow').forEach(function (arrow) {
            arrow.style.transform = arrow.style.transform === 'rotate(-180deg)' ? '' : 'rotate(-180deg)';
        });
    });

    //if url is floorplan page, grab the slug and set a selected class on the floorplan list item
    const url = window.location.href;
    const slug = url.substring(url.lastIndexOf('/') + 1);
    document.querySelectorAll('.header-floorplans-list li').forEach(function (li) {
        if (li.getAttribute('data-slug') === slug) {
            li.classList.add('selected');
            menuItemToScrollIntoView = li;
        }
    });
}

function initializeStickyBottomBar() {
    const bottomStickyBar = document.querySelector('.bottomStickyBar');
    if (!bottomStickyBar) return;

    document.getElementsByTagName('footer')[0].classList.add('bottomStickyBarPadding');

    let lastScrollTop = 0;
    let lastExecution = 0;

    // Show sticky bar when scrolling up, hide when scrolling down
    window.addEventListener('scroll', function () {
        if (bottomStickyBar) {
            window.addEventListener('scroll', function () {
                const now = Date.now();
                if (now - lastExecution >= 100) { // Throttle to 10 times per second
                    const isSlidDown = bottomStickyBar.classList.contains('slide-down');
                    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    if (currentScrollTop > lastScrollTop && !isSlidDown) {
                        // Scrolling down
                        bottomStickyBar.classList.add('slide-down');
                    } else if (currentScrollTop < lastScrollTop && isSlidDown) {
                        // Scrolling up
                        bottomStickyBar.classList.remove('slide-down');
                    }
                    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
                    lastExecution = now;
                }
            });
        }
    });

    // Show sticky bar if it gets focus during keyboard navigation
    window.addEventListener('focusin', function (event) {
        if (bottomStickyBar && event.target.closest('.bottomStickyBar')) {
            bottomStickyBar.classList.remove('slide-down');
        }
    });

    // Hide sticky bar half-way if it loses focus during keyboard navigation and the user has scrolled down
    window.addEventListener('focusout', function (event) {
        if (bottomStickyBar && !event.target.closest('.bottomStickyBar') && window.pageYOffset > 0) {
            bottomStickyBar.classList.add('slide-down');
        }
    });
}

/**
 * This allows keyboard tabbing to and from the mobile menu/button/trigger to work correctly
 * Without it, when the main navigation menu is open, the cursor/focus will tab to locations behind the main menu popup.
 * The logic handles the cases where the main navigation menu is open or closed, and where there is or is not a bottom sticky bar on the page.
 */
function headerAndStickyBarFocusTrap() {
    const htmlElement = document.documentElement;
    const headerLinks = Array.from(document.querySelectorAll('header a'));
    const mobileMenuTrigger = document.querySelector('header .mobileMenuTrigger');
    const bottomStickyBarLinks = Array.from(document.querySelectorAll('.bottomStickyBarActions a'));

    // if user is shift-tabbing from the mobile main menu button, and menu is open, then send focus to last BottomStickyBar item or last menu item
    if (mobileMenuTrigger) {
        mobileMenuTrigger.addEventListener('keydown', function (event) {
            if (event.shiftKey && event.key === 'Tab' && htmlElement.classList.contains('menuOpen')) {
                event.preventDefault();
                if (htmlElement.classList.contains('hasBottomStickyBar') && bottomStickyBarLinks.length > 0) {
                    const lastBottomStickyBarLink = bottomStickyBarLinks[bottomStickyBarLinks.length - 1];
                    lastBottomStickyBarLink.focus();
                } else if (headerLinks.length > 0) {
                    const lastHeaderLink = headerLinks[headerLinks.length - 1];
                    lastHeaderLink.focus();
                }
            }
        });
    }

    // if user is tabbing from last item in BottomStickyBar when mobile menu is open, then send focus to mobile main menu button
    if (bottomStickyBarLinks.length > 0) {
        const lastBottomStickyBarLink = bottomStickyBarLinks[bottomStickyBarLinks.length - 1];
        lastBottomStickyBarLink.addEventListener('keydown', function (event) {
            if (!event.shiftKey && event.key === 'Tab' && htmlElement.classList.contains('menuOpen')) {
                if (mobileMenuTrigger) {
                    event.preventDefault();
                    mobileMenuTrigger.focus();
                }
            }
        });
    } else {
        const lastHeaderLink = headerLinks[headerLinks.length - 1];
        lastHeaderLink.addEventListener('keydown', function (event) {
            if (!event.shiftKey && event.key === 'Tab' && htmlElement.classList.contains('menuOpen')) {
                if (mobileMenuTrigger) {
                    event.preventDefault();
                    mobileMenuTrigger.focus();
                }
            }
        });
    }
}

function initializeStickyHeader() {
    var header = document.getElementsByTagName('header')[0];

    if (typeof bypassStickyHeader === 'undefined' || !bypassStickyHeader) {
        window.addEventListener('scroll', function () {
            var cutoff = 0;
            var hasBanner = $('.banner-content:visible').length > 0;
            if (hasBanner) {
                cutoff = $('.banner-content').outerHeight();
            }
            if (window.scrollY > cutoff) {
                header.classList.add('scrolled');
                $('.skipNavBanner').addClass('fixed');
                if ($('.skipNavBanner').is(':focus-within')) {
                    header.classList.add('skipNavBannerShown');
                }
            } else {
                header.classList.remove('scrolled');
                $('.skipNavBanner').removeClass('fixed');
                header.classList.remove('skipNavBannerShown');
            }
        });
    } else {
        header.classList.add('scroll');
        document.getElementById('header-placeholder').style.height = 0;
    }
}

function getInnerContentHeight(parentContainer) {
    var height = 0;

    Array.from(parentContainer.children).forEach(function (child) {
        height += child.getBoundingClientRect().height;
    });

    return height;
}

function initializeDetailsSections() {
    var detailsSections = document.querySelectorAll('.detailsSection:not(.no-transitions)'),
        transitionTimeout,
        ARROW_BUTTON_SVG_TEMPLATE = '<button class="detailsToggleArrow" aria-label="display details toggle" aria-pressed="false"><svg class="detailsSectionSVGArrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.14 15.17"><path class="fill-primary" d="M.32.32a1.1,1.1,0,0,0,0,1.56h0l13,13a1.1,1.1,0,0,0,1.56,0h0l13-13A1.1,1.1,0,1,0,26.26.32L14.07,12.51,1.88.32A1.1,1.1,0,0,0,.32.32Z"/></svg></button>',
        CONTENT_SHOWN_CLASS = 'shown',
        TRANSITION_FINISHED_CLASS = 'transitionFinished',
        TRANSITION_TIME = 250;

    function showContent(detailsSection, detailsContent, detailsToggleArrow) {
        detailsSection.classList.add(CONTENT_SHOWN_CLASS);
        detailsContent.style.height = Math.ceil(getInnerContentHeight(detailsContent)) + 'px';
        detailsToggleArrow.setAttribute('aria-pressed', 'true');

        clearTimeout(transitionTimeout);
        transitionTimeout = setTimeout(function () {
            detailsSection.classList.add(TRANSITION_FINISHED_CLASS);
        }, TRANSITION_TIME);
    }

    function hideContent(detailsSection, detailsContent, detailsToggleArrow) {
        detailsSection.classList.remove(TRANSITION_FINISHED_CLASS);
        detailsToggleArrow.setAttribute('aria-pressed', 'false');
        clearTimeout(transitionTimeout);

        //Waiting for class name removal.
        transitionTimeout = setTimeout(function () {
            detailsSection.classList.remove(CONTENT_SHOWN_CLASS);
            detailsContent.style.height = '';
        }, 100);
    }

    function setupDisplayToggle(detailsSection) {
        var detailsContent = detailsSection.querySelector('.detailsSectionContent');
        var detailsToggleArrow = detailsSection.querySelector('.detailsToggleArrow');
        detailsSection.querySelector('.detailsSectionHeader').addEventListener('click', function () {
            if (detailsSection.classList.contains(CONTENT_SHOWN_CLASS)) {
                hideContent(detailsSection, detailsContent, detailsToggleArrow);
            } else {
                showContent(detailsSection, detailsContent, detailsToggleArrow);
            }
        });
    }

    function addArrowSVG(detailsSection) {
        var detailsHeader = detailsSection.querySelector('.detailsSectionHeader'),
            arrowButtonContainer = document.createElement('div');
        arrowButtonContainer.innerHTML = ARROW_BUTTON_SVG_TEMPLATE;
        detailsHeader.appendChild(arrowButtonContainer.firstChild);
    }

    Array.from(detailsSections).forEach(function (detailsSection) {
        addArrowSVG(detailsSection);
        setupDisplayToggle(detailsSection);
    });
}

function getScrollDuration(time, idealPixels, actualPixels) {
    var timePerPixel = time / idealPixels;
    return Math.floor(timePerPixel * actualPixels);
}

function scrollIntoView($target, time, idealPixels, opts) {
    var offsetTop = $target.offset().top,
        options = (opts != null ? opts : {}),
        $topBar = $('header');

    if ($topBar.length) {
        offsetTop -= $topBar.outerHeight();
    }

    if (time != null && idealPixels != null) {
        options.duration = getScrollDuration(time, idealPixels, offsetTop);
    }

    $('html,body').animate({
        scrollTop: offsetTop
    }, options);
}

function init() {
    initializeMobileMenu();
    initializeStickyHeader();
    initializeStickyBottomBar();
    headerAndStickyBarFocusTrap();
    initializeDetailsSections();
    wrapSelects(document);
    wrapCheckboxes(document);
}

// Function is duplicated in mobile/preview.mustache
function getMapLink(queryString, directGMBLink) {
    // if it's on mobile and not safari, return the google maps link
    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 && navigator.userAgent.indexOf('CriOS') === -1) {
        // Safari
        if (!!queryString) {
            return 'maps://maps.apple.com?q=' + queryString;
        } else {
            return 'maps://maps.apple.com';
        }
    } else {
        // Not Safari
        if (!!directGMBLink) {
            return directGMBLink;
        }
        if (!!queryString) {
            return 'https://maps.google.com?q=' + queryString;
        } else {
            return 'https://maps.google.com';
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    jQuery(function ($) {
        $('.scrollToButton').on('click', function (event) {
            var $this = $(this),
                $target = $($this.data('target'));

            event.preventDefault();
            scrollIntoView($target, 1000, 1500);
        });

    });

    init();
});

function autoCorrectPhoneOnChange(phoneField) {
    var phoneCharacters = phoneField.value.replace(/\D/g, '').split('');
    var newPhoneValue = '';
    for (var i = 0; i < phoneCharacters.length; i++) {
        if (i == 0) {
            newPhoneValue += '(';
        } else if (i == 3) {
            newPhoneValue += ') ';
        } else if (i == 6) {
            newPhoneValue += '-';
        }
        if ($.isNumeric(phoneCharacters[i])) {
            newPhoneValue += phoneCharacters[i];
        }
    }
    phoneField.value = newPhoneValue;
}

function toggleSkipNavBanner(focus) {
    if ($('.skipNavBanner').hasClass('fixed')) {
        if (focus === 'focusIn') {
            $('header').addClass('skipNavBannerShown');
        } else if (focus === 'focusOut') {
            $('header').removeClass('skipNavBannerShown');
        }
    }
}

function skipToContent() {
    // focus on the first tabbable element inside of the element with class mainContent
    $('.mainContent').find(':tabbable').first().focus();
}